module.exports = __webpack_public_path__ + "static/media/play-store-en.0ed66378.svg";